import type { HITLRendererProps } from '../HITLRenderer';
import { hitlStyles, cn } from './styles';

export const YesNoRenderer: React.FC<HITLRendererProps> = ({
  response,
  onSubmit,
  isSubmitting,
  compact,
}) => {
  const handleYes = () => onSubmit('yes');
  const handleNo = () => onSubmit('no');

  return (
    <div className={compact ? hitlStyles.containerCompact : hitlStyles.container}>
      {response.message && (
        <p className={hitlStyles.message}>{response.message}</p>
      )}
      
      {response.context && (
        <p className={hitlStyles.context}>{response.context}</p>
      )}

      <div className="flex gap-3">
        <button
          onClick={handleYes}
          disabled={isSubmitting}
          className={cn(
            'flex-1 py-3 px-4 rounded-lg font-medium text-sm transition-colors border-2',
            'bg-green-50 border-green-200 text-green-800 hover:bg-green-100 hover:border-green-300',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
        >
          {isSubmitting ? (
            <span className="flex items-center justify-center gap-2">
              <span className="animate-spin h-4 w-4 border-2 border-green-600 border-t-transparent rounded-full" />
            </span>
          ) : (
            '✓ Yes'
          )}
        </button>
        <button
          onClick={handleNo}
          disabled={isSubmitting}
          className={cn(
            'flex-1 py-3 px-4 rounded-lg font-medium text-sm transition-colors border-2',
            'bg-red-50 border-red-200 text-red-800 hover:bg-red-100 hover:border-red-300',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
        >
          ✗ No
        </button>
      </div>
    </div>
  );
};

